var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"bankAccountModal","size":"lg","hide-footer":""},scopedSlots:_vm._u([{key:"modal-title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('clientSessions.detail.bankAccount.modal.heading'))+" ")]},proxy:true}])},[_c('bank-account',{attrs:{"bank-account":_vm.bankAccount,"uploads":_vm.accountUploads}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }